export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/CardsVideo-eccc98cb02c013aa520c36de34c6ba01.mp4";